export default __webpack_public_path__ + "static/media/skydev-logo.a4c86122.png";